import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';
import { ContractListItemSource } from '../models/contractListItemSource';
import { ContractSource } from '../models/contractSource';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { PropertyListItem } from '../models/propertyListItem';
import { Property } from '../models/property';

@Injectable()
export class PaymentService {

    constructor(private http: HttpClient, private global: Env) { }

    getAllByProperty( property:string , page:number = 0 ):Observable<any[]>{
      
      const url = this.global.payment+'/search_property?propertyId='+property+'&pageSize=10&page='+page;
      console.log(url);
      return this.http.get(url).map((res: any[]) => {
        return res;
      });
    }
    //pago, division, status del pago paid,agente, moneda 
    /*
    get(id):Observable<Property[]> {
      const url = this.global.property+'/'+id;
      return this.http.get(url).map((res: Property[]) => {
        return res;
      });
    }
    */
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/payment.service.ts